<template>
  <div class="container-form">
    <header-component :title="translate.headerTitle" />
    <main>
      <p>{{ translate.formTitle }}</p>
      <div class="card">
        <b-form @submit.stop.prevent="onSubmit" v-if="show">
          <b-row>
            <!-- Razão Social -->
            <b-col md="4">
              <b-form-group
                id="input-name-group"
                :label="translate.name"
                :invalid-feedback="translate.invalid_feedback"
              >
                <b-form-input
                  id="input-name"
                  v-model="model.name"
                  type="text"
                  :placeholder="translate.name_placeholder"
                  :state="validateState('name')"
                />
              </b-form-group>
            </b-col>

            <!-- CNPJ -->
            <b-col md="4">
              <b-form-group
                id="input-group-cnpj"
                :label="translate.cnpj"
                :invalid-feedback="invalidFeedbackCNPJ"
              >
                <input-cnpj
                  :model.sync="model.cnpj"
                  :placeholder="translate.cnpj_placeholder"
                  :state="validateState('cnpj')"
                />
              </b-form-group>
            </b-col>

            <!-- Responsável -->
            <b-col md="4">
              <b-form-group
                id="input-group-responsible"
                :label="translate.responsible"
                :invalid-feedback="translate.invalid_feedback"
              >
                <b-form-input
                  id="input-responsible"
                  v-model="model.responsible"
                  :placeholder="translate.responsible_placeholder"
                  :state="validateState('responsible')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Segmentos -->
          <check-box
            :label="translate.segments"
            :id="'segments'"
            :options="segmentOptions"
            :model.sync="model.segment"
            :state="validateState('segment')"
            :invalidFeedback="translate.invalid_feedback"
          />

          <b-row>
            <!-- CEP -->
            <b-col md="4">
              <b-form-group
                id="input-group-1"
                :label="translate.zipcode"
                label-for="input-1"
              >
                <input-cep
                  :model.sync="model.zipcode"
                  :placeholder="translate.zipcode_placeholder"
                  :state="validateState('zipcode')"
                  :updateAddress="updateAddress"
                />
                <b-form-invalid-feedback id="input-1-live-feedback">
                  {{ translate.invalid_feedback }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Cidade -->
            <b-col md="4">
              <b-form-group
                id="input-group-city"
                :label="translate.city"
                :invalid-feedback="translate.invalid_feedback"
              >
                <b-form-input
                  id="input-city"
                  v-model="model.city"
                  :placeholder="translate.city_placeholder"
                  :state="validateState('city')"
                />
              </b-form-group>
            </b-col>

            <!-- Estado -->
            <b-col md="4">
              <b-form-group
                id="input-group-state"
                label="UF"
                :invalid-feedback="translate.invalid_feedback"
              >
                <select-state
                  :model.sync="model.state"
                  :validate="validateState('state')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <!-- E-mail -->
            <b-col md="4">
              <b-form-group
                id="input-group-email"
                :label="translate.email"
                :invalid-feedback="translate.invalid_feedback"
              >
                <b-form-input
                  id="input-email"
                  v-model="model.email"
                  type="email"
                  :placeholder="translate.email_placeholder"
                  :state="validateState('email')"
                />
              </b-form-group>
            </b-col>

            <!-- WhatsApp -->
            <b-col md="4">
              <b-form-group
                id="input-group-whatsApp"
                :label="translate.phone"
                :invalid-feedback="translate.invalid_feedback"
              >
                <input-phone
                  :model.sync="model.phone"
                  :placeholder="translate.phone_placeholder"
                  :state="validateState('phone')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Produtos -->
          <check-box
            :label="translate.products"
            :id="'products'"
            :options="productsOptions"
            :model.sync="model.product_interest"
            :isColumn="'activated'"
            :state="validateState('product_interest')"
            :invalidFeedback="translate.invalid_feedback"
          />

          <!-- Quantidade de Kits -->
          <b-row>
            <b-col lg="4" md="6">
              <b-form-group
                id="input-group-kits"
                :label="translate.kits"
                :invalid-feedback="'*Campo Obrigatório'"
                label-for="input-kits"
              >
                <b-form-select
                  id="input-kits"
                  v-model="model.kits"
                  :options="kitsOptions"
                  :state="validateState('kits')"
                  style="font-size: 12px"
                  :disabled="!kitsOptions.length"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Canal de Atendimento -->
          <check-box
            :label="translate.services"
            :id="'services'"
            :options="serviceOptions"
            :model.sync="model.contact_by"
            :state="validateState('contact_by')"
            :invalidFeedback="translate.invalid_feedback"
          />

          <b-col
            md="12"
            class="d-flex justify-content-center align-items-center"
          >
            <b-button type="submit" variant="primary">
              {{ translate.button }}
            </b-button>
          </b-col>
        </b-form>
      </div>
    </main>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { isCNPJ } from 'validation-br';

import { productsOptions, segmentOptions, serviceOptions } from '@/utils';
import Events from '../utils/events';
import HeaderComponent from './Header.vue';
import CheckBox from '@/shared/CheckBox.vue';
import InputPhone from '@/shared/InputPhone.vue';
import SelectState from '@/shared/SelectState.vue';
import InputCep from '@/shared/InputCep.vue';
import InputCnpj from '@/shared/InputCnpj.vue';
import { formPt, formEs } from '../lang';
import LeadService from '../service/lead';
import ResellerServices from '../service/reseller';
import { lead } from './mockup';

export default {
  name: 'form-register',
  components: {
    HeaderComponent,
    CheckBox,
    InputPhone,
    SelectState,
    InputCep,
    InputCnpj,
  },
  mixins: [validationMixin],
  data() {
    return {
      model: { ...lead, kits: null  },
      translate: { ...formPt },
      segmentOptions,
      productsOptions,
      serviceOptions,
      show: true,
      kitsOptions: [],
    };
  },
  validations: {
    model: {
      name: { required },
      cnpj: { required, isValidCNPJ: isCNPJ },
      city: { required },
      email: { required },
      responsible: { required },
      state: { required },
      phone: { required },
      country: { required },
      zipcode: { required },
      product_interest: { required },
      kits: { required },
      contact_by: { required },
      segment: { required },
    },
  },
  computed: {
    invalidFeedbackCNPJ() {
      const isValid = !this.$v.model.cnpj.isValidCNPJ;
      return isValid && this.model.cnpj
        ? this.translate.invalid_feedback_cnpj
        : this.translate.invalid_feedback;
    },
  },
  methods: {
    checkLanguage() {
      const language = this.$route.params.language;
      if (language) {
        switch (language) {
          case 'es':
            return (this.translate = formEs);
          default:
            return (this.translate = formPt);
        }
      }
    },
    onSubmit() {
      this.$v.model.$touch();
      if (this.$v.model.$anyError) {
        return;
      }
      const { kit_quantity, kit_condition } = this.model.kits;
      const newLeadValues = { ...this.model, kit_quantity, kit_condition };
      delete newLeadValues.kits;

      LeadService.save(newLeadValues)
        .then(response => {
          this.$router.push({
            name: 'result',
            query: { businessName: this.model.name, type: response.type  },
          });
        })
        .catch(error => {
          console.log('error', error);
        });
    },
    updateAddress({ city, state }) {
      this.model.city = city;
      this.model.state = state;
      this.getKits({ city, state });
    },
    async getKits({ city, state }) {
      const options = await ResellerServices.getKits({ city, state });
      const defaultOption = { text: 'Selecione uma opção', value: null };

      this.kitsOptions = [defaultOption, ...options];
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.model[name];
      return $dirty ? !$error : null;
    },
  },
  mounted() {
    this.checkLanguage();
    Events.$on('change_translate', () => {
      this.checkLanguage();
    });
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  font-size: 12px;
}

legend {
  font-size: 12px;
}

.form-control.is-valid {
  border-color: #ced4da;
  background-image: none;
  box-shadow: none;
}

.form-control.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.form-control.is-invalid:focus {
  box-shadow: none;
}

.custom-select.is-valid {
  border-color: #ced4da;
  background: #fff
    url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e')
    right 0.75rem center/8px 10px no-repeat;
}

.custom-select.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.row {
  font-size: 12px;
}

input:focus {
  border-color: #000;
  box-shadow: none;
}

select:focus {
  border-color: #000;
  box-shadow: none;
}

.custom-select.is-valid:focus {
  border-color: #000;
  box-shadow: none;
}

.container-form {
  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;
    max-width: 1140px;
    width: 90%;
    margin-inline: auto;
    margin-top: 60px;

    p {
      margin-bottom: 16px;
      text-align: center;
    }

    .card {
      padding: 2rem;
      width: 100%;
      border: 1px solid #dfe0e0;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 24px;
      .title {
        position: relative;
        h2 {
          font-weight: normal;
        }
        p {
          margin: 35px 0;
          font-size: 16px;
        }
      }
      legend {
        font-size: 12px;
      }

      button {
        color: #011640;
        background-color: #66ded0;
        background-image: linear-gradient(180deg, #66ded0 0%, #5bb6ff 100%);
        border-width: 0px;
        border-radius: 20px;
        padding: 12px 20px 12px 20px;
        font-size: 15px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }
}
</style>
